import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useModal, DropDown } from '@mssgme/ui';

import AssignOption from './AssignOption';
import ToggleButton from './ToggleButton';

import styles from './AssignFilter.scss';

AssignFilter.propTypes = {
    onChange: PropTypes.func.isRequired,
    onToggle: PropTypes.func,
    value: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
};

export default function AssignFilter({ onChange, onToggle, options, value }) {
    const { isOpen, toggle, hide } = useModal();
    const currentOption = options.find((o) => o.value === value);

    useEffect(() => {
        onToggle && onToggle(isOpen);
    }, [isOpen]);

    const handleSelect = (v) => {
        onChange(v);
        hide();
    };

    return (
        <div className={styles.root}>
            <div className={styles.toggle}>
                <h1 className={styles.label}>
                    {currentOption.label + ' '}
                    {currentOption.meta.count != null && <span>({currentOption.meta.count})</span>}
                </h1>
                <ToggleButton isPressed={isOpen} onToggle={toggle} />
            </div>
            <DropDown in={isOpen}>
                <ul className={styles.menu}>
                    {options.map((option, key) => (
                        <AssignOption
                            key={key}
                            isSelected={option.value === value}
                            onSelect={handleSelect}
                            {...option}
                        />
                    ))}
                </ul>
            </DropDown>
        </div>
    );
}
